export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrows-expand-a8e94a6784c94aaedd2f396c1067f34b.svg";